"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M4.5 6A1.5 1.5 0 0 0 3 7.5v8A1.5 1.5 0 0 0 4.5 17h1a2 2 0 1 0 4 0h5a2 2 0 1 0 4 0h1a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-.01-.098l-.678-3.392A2.5 2.5 0 0 0 17.86 8H15v-.5A1.5 1.5 0 0 0 13.5 6zm13.732 10a2 2 0 0 0-3.464 0H9.232a2 2 0 0 0-3.464 0H4.5a.5.5 0 0 1-.5-.5V14h16v1.5a.5.5 0 0 1-.5.5zM14 13H4V7.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5zm5.89 0H15V9h2.86a1.5 1.5 0 0 1 1.471 1.206zM7.5 16a1 1 0 1 1 0 2 1 1 0 0 1 0-2m9 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
}), 'Truck');
//# sourceMappingURL=index.js.map